import type UpdateAffiliateOnboardingDto from '../../models/affiliateOnboarding/updateAffiliateOnboardingDto';
import { requests } from '../httpClient';

export const AffiliateOnboarding = {
    getAffiliateOnboardingDetailsAsync: () => requests.get(`AffiliateOnboarding`),
    getAffiliateOnboardingCanPayStatusCodesAsync: () => requests.get(`AffiliateOnboarding/CanPayStatusCodes`),
    updateAffiliateOnboardingDetailsAsync: (data: UpdateAffiliateOnboardingDto) => requests.put(`AffiliateOnboarding`, data),
    basketAsync: () => requests.post(`AffiliateOnboarding/Basket`, {})
};
